export default __webpack_public_path__ + "296ecab010b539b84133920b7351f464.png";